<div class="mp-shell flex bg-mp-bg text-mp-fg font-mp">

  <!-- DESKTOP / TABLET: left navigation rail -->
  @if (!hideTabs()) {
  <aside class="mp-shell__rail hidden lg:flex flex-col w-64 shrink-0 border-r border-mp-line/10 px-4 py-6 gap-2">
    <a routerLink="/for-you" class="flex items-center gap-3 px-2 mb-6">
      <mat-icon svgIcon="mp-mindpop_logo_big" class="mp-icon !w-10 !h-10 rounded-xl overflow-hidden"></mat-icon>
      <span class="text-2xl font-bold">Mindpop</span>
    </a>
    @for (tab of tabs; track tab.key) {
    <a [routerLink]="tab.route" (click)="onTabClick(tab)" class="flex items-center gap-4 h-14 px-3 rounded-2xl text-lg font-bold transition-colors"
      [class]="isActive(tab) ? 'bg-mp-nav text-primary-green' : 'text-mp-fg hover:bg-mp-fg/5'">
      <!-- Mono icons in the page color (white in dark mode), petrol on a white box when selected -->
      <span class="w-9 h-9 flex items-center justify-center rounded-xl" [class]="isActive(tab) ? 'bg-white text-primary-green' : 'text-mp-fg'">
        @if (tab.key === 'for-you') {
        <mat-icon svgIcon="mp-mindpop_logo_big" class="mp-icon !w-8 !h-8 rounded-lg overflow-hidden"></mat-icon>
        } @else {
        <mat-icon [svgIcon]="tab.icon" class="mp-icon mp-icon--current !w-8 !h-8"></mat-icon>
        }
      </span>
      {{ tab.label | translate }}
    </a>
    }
    <div class="flex-auto"></div>
    <button type="button" class="flex items-center gap-4 h-14 px-3 rounded-2xl text-lg font-bold text-mp-fg hover:bg-mp-fg/5" (click)="logout()"
      [matTooltip]="'Mindpop.Settings.Logout' | translate">
      <span class="w-9 h-9 flex items-center justify-center rounded-xl">
        <mat-icon svgIcon="mp-logout" class="mp-icon mp-icon--current !w-8 !h-8"></mat-icon>
      </span>
      {{ 'Mindpop.Settings.Logout' | translate }}
    </button>
  </aside>
  }

  <!-- PHONE COLUMN -->
  <div class="mp-shell__column flex-auto flex flex-col min-w-0 w-full">
    <main class="mp-shell__content flex-auto relative min-h-0">
      @if (isForbidden()) {
      <div class="p-8 text-center">
        <h3 class="text-lg font-semibold">{{ 'General.You do not have access to this item' | translate }}</h3>
        <p class="text-mp-muted mt-2">{{ 'General.In most cases, the item you wanted to access requires permissions that you do not have.' | translate }}</p>
      </div>
      } @else if (notFound()) {
      <div class="p-8 text-center">
        <h3 class="text-lg font-semibold">{{ 'General.The item you were looking for could not be found' | translate }}</h3>
        <p class="text-mp-muted mt-2">{{ 'General.In most cases, the item you wanted to access does not exist or has been deleted.' | translate }}</p>
      </div>
      } @else {
      <router-outlet></router-outlet>
      }
    </main>

    <!-- PHONE: floating tab bar -->
    @if (!hideTabs()) {
    <nav class="mp-shell__tabs lg:hidden shrink-0 flex items-end gap-1 px-2 pb-2 pt-2 bg-mp-bar">
      <button type="button" [matTooltip]="'Mindpop.Tooltips.Notifications' | translate" class="w-6 h-6 shrink-0 mb-5 opacity-80 text-mp-fg" aria-label="Notifications">
        <mat-icon svgIcon="mp-notification_bell" class="mp-icon mp-icon--current !w-6 !h-6"></mat-icon>
      </button>
      <div class="flex-auto flex items-end justify-between rounded-full bg-mp-nav px-2 pt-2 pb-1.5">
        @for (tab of tabs; track tab.key) {
        <!-- Natural widths with nowrap labels: long labels (Wiederholen) never break mid-word, worst case they truncate -->
        <a [routerLink]="tab.route" (click)="onTabClick(tab)" class="flex flex-col items-center gap-0.5 min-w-0">
          @if (tab.key === 'for-you') {
          <span class="w-11 h-11 rounded-xl overflow-hidden shadow-md ring-2 ring-mp-mint/60 -mt-3">
            <mat-icon svgIcon="mp-mindpop_logo_big" class="mp-icon !w-11 !h-11"></mat-icon>
          </span>
          } @else {
          <!-- Mono icons (search, revise) are tinted in the passive tone of the two-tone icons -->
          <mat-icon [svgIcon]="tab.icon" class="mp-icon !w-9 !h-9" [class.mp-icon--current]="tab.key === 'search' || tab.key === 'revision'"
            [class.text-mp-passive]="tab.key === 'search' || tab.key === 'revision'"></mat-icon>
          }
          <span class="text-[13px] font-bold leading-4 px-1.5 py-0.5 rounded-full whitespace-nowrap max-w-full truncate"
            [class]="isActive(tab) ? 'bg-turquoise text-white' : 'text-primary-green'">{{ tab.label | translate }}</span>
        </a>
        }
      </div>
      <div class="w-3 shrink-0 flex flex-col items-center gap-1 mb-5">
        <span class="w-1.5 h-1.5 rounded-full bg-mp-fg/70"></span>
        <span class="w-1.5 h-1.5 rounded-full bg-mp-fg/70"></span>
        <span class="w-1.5 h-1.5 rounded-full bg-mp-fg/70"></span>
        <span class="w-1.5 h-1.5 rounded-full bg-mp-red"></span>
      </div>
    </nav>
    }
  </div>
</div>
